import React from 'react';
import classNames from 'classnames';
import { ModalFooterProps } from '../types';
import { useModalContext } from '../ModalContext';

import styles from './index.module.scss';

const ModalFooter = ({ children }: ModalFooterProps) => {
  const { centered, mobileFullScreen } = useModalContext();

  return (
    <div
      className={classNames(
        styles.container,
        { [styles.centered]: centered },
        { [styles.mobileResponsive]: !mobileFullScreen }
      )}
    >
      {children}
    </div>
  );
};

ModalFooter.displayName = 'ModalFooter';

export default ModalFooter;
